import script from "./SiteDisplaySettings.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteDisplaySettings.vue?vue&type=script&setup=true&lang=js"

import "./SiteDisplaySettings.vue?vue&type=style&index=0&id=1396a0a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1396a0a7"]])

export default __exports__